import React from 'react';

export const assetStatus = (status, style = {}) =>
  status === 'Broken' ? (
    <span style={style} className="ticket_status_label_title small pending">
      Broken
    </span>
  ) : status === 'WO Outstanding' ? (
    <span style={style} className="ticket_status_label_title small ontheway">
      WO Outstanding
    </span>
  ) : status === 'Replace' ? (
    <span style={style} className="ticket_status_label_title small scheduled">
      Replace
    </span>
  ) : status === 'Inactive' ? (
    <span style={style} className="ticket_status_label_title small inactive">
      Inactive
    </span>
  ) : status === 'Offline' ? (
    <span style={style} className="ticket_status_label_title small open">
      Offline
    </span>
  ) : status === 'Service Due' ? (
    <span style={style} className="ticket_status_label_title small fixing">
      Service Due
    </span>
  ) : status === 'Reviewed' ? (
    <span style={style} className="ticket_status_label_title small reviewed">
      Reviewed
    </span>
  ) : (
    <span style={style} className="ticket_status_label_title small closed">
      Healthy
    </span>
  );
